var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-area"},[_c('label',{staticClass:"input-title"},[_vm._v(_vm._s(_vm.component.label))]),_c('textarea',{staticClass:"input-area",attrs:{"placeholder":_vm.component.placeholder}})])
}
var staticRenderFns = []

export { render, staticRenderFns }